import { Menu, MenuItem } from '@soteria/design-system-ve';
import { useCallback } from 'react';

import type { GraphQLAuditDecision } from '../../../domain/graphql-types';

interface ActionMenuProps {
  /** Whether the action menu is open */
  isOpen: boolean;
  /** ID of the trigger button for accessibility */
  triggerId: string;
  /** Current user decision (if any) */
  currentUserDecision?: GraphQLAuditDecision;
  /** Callback when menu should close */
  onClose: () => void;
  /** Callback when delete action is selected */
  onDelete: () => void;
  /** Callback when skip action is selected */
  onSkip: () => void;
}

/**
 * ActionMenu component for audit decision panel actions
 * Provides delete decision and skip audit item functionality
 */
export function ActionMenu({ isOpen, triggerId, currentUserDecision, onClose, onDelete, onSkip }: ActionMenuProps) {
  const handleDeleteClick = useCallback(() => {
    onClose();
    onDelete();
  }, [onClose, onDelete]);

  const handleSkipClick = useCallback(() => {
    onClose();
    onSkip();
  }, [onClose, onSkip]);

  return (
    <Menu
      ariaLabel="Decision actions menu"
      isOpen={isOpen}
      placement="top end"
      showCloseButton={false}
      triggerId={triggerId}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <MenuItem label={currentUserDecision ? 'Delete Decision' : 'Delete Decision (No decision to delete)'} onClick={handleDeleteClick} />
      <MenuItem label="Skip Audit Item" onClick={handleSkipClick} />
    </Menu>
  );
}
